import { PALO_ALTO_NETWORKS_DETAILS } from './constants';

export const isPaloAltoNetworksPartner = ({ id, partnerName = '' } = {}) => {
  return id === PALO_ALTO_NETWORKS_DETAILS.id || (typeof partnerName === 'string' && Boolean(partnerName.match(/palo alto/gi)));
};
